import styled from 'styled-components/macro';
import tw from 'tailwind.macro';
import { colors } from '../../../styles/constants';

const CompanySibling = styled.div`
  ${tw`flex flex-col items-center w-full pt-abs4 mx-def mb-abs6`};
  border-top: 1px solid ${colors.grey200};
`;

const Children = styled.div`
  ${tw`flex flex-wrap justify-center mt-def`};
`;

const ChildLogo = styled.img`
  ${tw`h-auto w-auto`}
  max-width:100%;
  max-height: 100%;
`;

const ChildLink = styled.a`
  ${tw`flex items-center m-def`}
  max-height: 50px;
  max-width: 125px;
  color: ${colors.secondary400};
  font-weight: 600;
  text-decoration: none;
`;

export { ChildLink, ChildLogo, Children, CompanySibling };
